import { render } from "./NewsCards.vue?vue&type=template&id=7885c8e5"
import script from "./NewsCards.vue?vue&type=script&lang=js"
export * from "./NewsCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__